module.exports = __webpack_public_path__ + "static/media/Biko_Regular.7cf27339.otf";